import { useAuth } from '@/context/AuthProvider';
import { useIsSuperuser } from '@/api/user/useUserQuery';
import { useOrganizationGate } from '@/hooks/useOrganizationGate';
import LoadingScreen from '@/components/LoadingScreen';
import LoginScreen from '@/pages/login-screen';
import SelectOrganization from '@/pages/select-organization';
import { Navigate } from 'react-router';

interface ProtectedProps {
  children: React.ReactNode;
  requireSuperuser?: boolean;
}

function Protected({ children, requireSuperuser }: ProtectedProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return (
    <AuthenticatedContent requireSuperuser={requireSuperuser}>
      {children}
    </AuthenticatedContent>
  );
}

function AuthenticatedContent({ children, requireSuperuser }: ProtectedProps) {
  const isSuperuser = useIsSuperuser();
  const orgGate = useOrganizationGate();

  if (orgGate.isLoading) {
    return <LoadingScreen />;
  }

  if (orgGate.needsSelection) {
    return <SelectOrganization organizations={orgGate.organizations} />;
  }

  if (requireSuperuser && !isSuperuser) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default Protected;
